module.exports = __webpack_public_path__ + "static/media/gb-eng.2b292d90.webp";